{
  "titles": {
    "menuTitle": "Account",
    "account": "Account",
    "personalInformation": "Persoonlijke gegevens",
    "security": "Beveiliging",
    "companyDetails": "Bedrijfsgegevens",
    "partner": "Mijn adviseur | Mijn adviseurs",
    "documents": "Documenten",
    "bankConnections": "Bankverbindingen",
    "quotesAndAgreements": "Offertes en overeenkomsten",
    "guaranteesAndOtherConditions": "Zekerheden en overige voorwaarden",
    "annualStatements": "Jaaroverzichten",
    "annualStatement": "Jaaroverzicht {year}"
  },
  "messages": {
    "soon": "Binnenkort kan je hier jouw gegevens, wachtwoord en meer wijzigen.",
    "security": "Je logt eenvoudig in met je e-mailadres en een unieke code, extra beveiligd via tweestapsverificatie (2FA). Zo zijn je gegevens altijd optimaal beschermd en hoef je geen wachtwoord meer te onthouden of te wijzigen.\n\n Wil je je e-mailadres aanpassen? Neem dan even contact op, we helpen je graag verder.",
    "wrongInfo": "Zie je iets wat niet klopt?",
    "contactUs": "Neem contact op",
    "noDocuments": "Er zijn nog geen documenten beschikbaar."
  },
  "fields": {
    "name": "Naam",
    "email": "E-mail",
    "phone": "Telefoon",
    "companyName": "Bedrijfsnaam",
    "registrationNumber": "KvK-nummer",
    "address": "Adres",
    "labels": {
      "name": "Roepnaam",
      "firstNames": "Voornaam",
      "lastName": "Achternaam",
      "email": "E-mail",
      "phone": "Telefoon",
      "companyName": "Bedrijfsnaam",
      "registrationNumber": "KvK-nummer",
      "address": "Adres"
    }
  },
  "notifications": {
    "messages": "Ontvang een e-mail bij een bericht in de berichtenbox"
  },
  "actions": {
    "logout": "Uitloggen",
    "contactDebitRoom": "Contact opnemen"
  }
}
